export default "__VITE_ASSET__j89Z7qRZ__"